import { Skeleton } from '@/components/feedback/Skeleton/Skeleton';

import './AuthPageSkeleton.scss';

/**
 * Loading skeleton for authentication pages (login/register)
 * Matches the layout of auth forms
 */
export default function AuthPageSkeleton() {
  return (
    <div className="auth-page-skeleton">
      <div className="auth-page-skeleton-container">
        {/* Title */}
        <Skeleton variant="text" width="60%" height="32px" />

        {/* Subtitle */}
        <Skeleton variant="text" width="45%" height="16px" />

        <div className="auth-page-skeleton-form">
          {/* Email field */}
          <div className="auth-page-skeleton-field">
            <Skeleton variant="text" width="60px" height="14px" />
            <Skeleton variant="rect" width="100%" height="44px" />
          </div>

          {/* Password field */}
          <div className="auth-page-skeleton-field">
            <Skeleton variant="text" width="80px" height="14px" />
            <Skeleton variant="rect" width="100%" height="44px" />
          </div>

          {/* Submit button */}
          <Skeleton variant="rect" width="100%" height="44px" />
        </div>

        {/* Footer */}
        <Skeleton variant="text" width="70%" height="14px" />
      </div>
    </div>
  );
}
